<template>
  <!-- <HelloWorld msg="Welcome to Your Vue.js App" /> -->
  <router-view />
</template>

<script setup></script>
